export { default, } from './Component';
export { SIZE, } from './constants';
